import "core-js/modules/es6.regexp.split";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import mainViewMixin from '../mainViewMixin';
export default {
  name: 'ViewNiotaClassicConsumersConsumerList',
  mixins: [mainViewMixin],
  data: function data() {
    return {
      isLoadingAccounts: true,
      selectedAccounts: []
    };
  },
  computed: {
    headerBG: function headerBG() {
      return './img/consumer.png';
    }
  },
  methods: {
    editConsumer: function editConsumer(item) {
      this.pushToRouter("/niota-classic/consumers/".concat(item.id));
    },
    pushToRouter: function pushToRouter(path) {
      this.$router.push({
        path: path
      });
    },
    resetFilter: function resetFilter() {
      this.selectedAccounts = [];
    },
    getAccountsIdsFromQueryParams: function getAccountsIdsFromQueryParams() {
      return (this.$route.query.accounts || '').split(',').map(function (i) {
        return parseInt(i, 10);
      });
    }
  }
};